import * as yup from "yup";
export const agregarRechazo = yup.object().shape({
    MotivoRechazo: yup.mixed().required(),   
   // comentario: yup.string().required()
});